import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { UserService } from '../../services/user.service';
import { ApiCallCachingService } from '../../services/api-call-caching.service';

import { DropdownBaseComponent } from './dropdown-base/dropdown-base.component';
import { UserListItem } from '../../models/users/user-list-item.model';

@Component({
    selector: 'spv2-users-dropdown',
    templateUrl: './dropdown-base/dropdown-base.component.html',
    styleUrls: ['./dropdown-base/dropdown-base.component.scss'],
    standalone: false
})
export class UsersDropdownComponent extends DropdownBaseComponent<string, UserListItem> implements OnChanges {
  @Input() showForPolicyId: number;

  uniqueName = "users";

  textField = "displayName";
  valueField = "mail";

  enableCache = false;
  
  dataFunction = (filter: string) => {
    if(filter) return this.userService.getUserList(this.showForPolicyId, !this.disabled, filter);
  };

  constructor(private userService: UserService, cachingService: ApiCallCachingService) {
    super(cachingService);
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Only check for changes while disabled, as the parent component handles the rest.
    if (this.disabled && changes.value && changes.value.currentValue !== changes.value.previousValue) {
      this.data$ = this.createReplaySubjectObservable(changes.value.currentValue);
    }
  }
}
